import React from "react";
import Form from "react-bootstrap/Form";

const settingsStyle = {
    textAlign: "center",
    margin: "1em 25% 0 25%",
};

const settingItemStyle = {
    marginBottom: "1.5em",
    textAlign: "left",
    padding: "1em",
    border: "1px solid #ccc",
    borderRadius: "0.5em",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
};

const Settings = ({ nightMode, setNightMode }) => {
    return (
        <div style={settingsStyle}>
            <h2>Settings</h2>
            <div style={settingItemStyle}>
                <label htmlFor="nightModeToggle">Night Mode</label>
                <Form.Check id="nightModeToggle" type="switch" checked={nightMode} onChange={(e) => setNightMode(e.target.checked)} />
            </div>
        </div>
    );
};

export default Settings;
